shadow$provide[77] = function(global,require,module,exports) {
module.exports=(pt_ts);
};